import {Component} from '@angular/core';

@Component({
    selector: 'app-megapopover',
    templateUrl: './megapopover.component.html',
    standalone: false
})

export class MegapopoverComponent {
  name = 'World';
}
